module.exports = __webpack_public_path__ + "media/images/gallery/constellations/cassiopeia/cas_lines-497b855f2c2a7b3bb1bb899058b0127c.gif";